





















































































































import {Component, Watch, Prop} from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BookingRoleWorkerStatus from '@/models/BookingRoleWorkers/BookingRoleWorkerStatus';
import { AgencyDashboardModule } from '@/store/modules/agencyDashboard';
import ShiftBookedStatus from '@/components/Shifts/Display/ShiftBookedStatus.vue';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue'
import WorkerDto from '@/models/Workers/WorkerDto';
import { AppModule } from '@/store/modules/app';
import ShiftTimesheetPdfDownload from '@/components/Shifts/ShiftTimesheetPdfDownload.vue';
import ajax from '@/lib/ajax';

@Component({
  name: 'RoleDateShiftSummary', components: { ShiftTimesheetPdfDownload, ShiftBookedStatus, ShiftStatus, BookingRoleWorkerShiftStatus }
})
export default class extends GiganautVueDialog {

    public dialog = false;

	  @Prop({required: true})
	  locationName: string;

	  @Prop({required: true})
	  positionName: string;

	  @Prop({required: true})
	  bookingId: string;

    @Prop({required: true})
    bookingDateId: string;

    @Prop({required: true})
    bookingRoleId: string;

    @Prop({required: true})
    required: number;

    @Prop({required: true})
    booked: number;

    @Prop({required: true})
    bookedUnconfirmed: number;

    @Prop({required: true})
    bookedConfirmed: number;

    @Prop({required: true})
    showPercentage: boolean;

    @Prop({required: true})
    showRatio: boolean;

    @Prop({required: true})
    showXSmall: boolean;

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            await AgencyDashboardModule.getRoleDateShiftSummary( { bookingId: this.bookingId, bookingDateId: this.bookingDateId, bookingRoleId: this.bookingRoleId })
        }
    }

	get shifts() {
		return AgencyDashboardModule.roleDateShifts;
	}

	get color() {
		let color = "orange";
		const percentage = this.bookedPercentage();
		if (percentage == 100){
			color = "green"
		} else if (percentage == 0) {
			color = "red";
		} else if (percentage > 100) {
			color = "dark green"
		}
		return color;
	}
	
	get textColor() {
		let color = "black";
		const percentage = this.bookedPercentage();
		if (percentage == 100){
			color = "black";
		} else if (percentage == 0) {
			color = "white";
		} else if (percentage > 100) {
			color = "black"
		}
		return color;
	}
	
	get text() {
		let text = "";
		if (this.showRatio){
			text = this.booked + "/" + this.required;
		}
		if (this.showPercentage) {
			const percentage = this.bookedPercentage();
			if (text !== "") {
				text = text + " ";
			}
			text = text + "" + percentage + "%";
		}
		return text;
	}

	get outlined() {
		const percentage = this.bookedPercentage();
		//if (percentage >= 100){
			if (this.bookedUnconfirmed > 0) {
				return true;
			}
		//}
		return false;
	}

	getWorkerAvatarUrl(worker: WorkerDto) {
		return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + worker.id + "/resized-100/" + worker.avatar;
	}
	
	bookedPercentage() {
		const percentage = 0;
		if (this.booked == 0) {
			return 0;
		}
		return Math.round((this.booked / this.required)*100);
	}
}
